/*
 *  Product Thumbnail Print
 *    Exporting common product thumbnail string.
 *
 *
 *  Version:
 *    1.0.0 - 2023/07/17
 */

import {
  pictureGenerate, printMoney, escapeString, handlize, t
} from '@process-creative/slate-theme-tools';

export const PTC = 'o-product-thumbnail';

export const ProductThumbnailPrint = (p, p2, v, clazz, url, dataAttribute, upsellContainer = null) => {
  //Detemine current variant ID to use
  let currentVariant = v.id || p.first_available_variant.id;

  //Determine which image to use
  let img = p.image || p.featured_image;

  //Cleanse title
  let titleCleansed = p.title.split('(')[0];

  const priceMin = p.variants.reduce((x,v) => {
    return x < v.price ? x : v.price;
  }, v.price);
  const priceMax = p.variants.reduce((x,v) => {
    return x > v.price ? x : v.price;
  }, v.price);

  const priceVaries = priceMin != priceMax;

  const CLASS_HIDDEN = 'is-hidden';

  return /*html*/`
    <div
      class="${PTC} ${clazz} ${p.hover_image? 'has-hover' : ''}"
      data-product-thumbnail
      data-upsell-item
      data-product-handle="${p.handle}"
      data-product-id="${p.id}"
      data-variant-id="${currentVariant}"
      ${dataAttribute ? dataAttribute : ''}
    >
      <script type="application/json" data-product-json>
        ${JSON.stringify(p2)}
      </script>
      <div class="${PTC}__inner">
        ${image()}
        <div class="${PTC}__details">
          <div class="${PTC}__title-container">
            <a
              href="${p.url}"
              title="${escapeString(p.title)}"
              class="${PTC}__title o-title"
              data-product-thumbnail-link
            >
              ${escapeString(titleCleansed)}
            </a>

            <div class="${PTC}__swatch-container">
              ${pricing()}
              ${upsellContainer ? getVariantSelector() : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  `

  function getVariantSelector() {
    const hasVisibleOptions = () => {
      if (p.variants.length === 1 && p.variants[0].option1 === 'Default Title' 
        && p.variants[0].option2 === null && p.variants[0].option3 === null) {
          return false;
      } else {
        return true;
      }
    }

    const options = p.variants.reduce((x, tempV) => {
      return x += `
        <option 
          value="${tempV.id}" ${v.id == tempV.id ? `selected` : ``}
          data-variant-option
        >
          ${escapeString(tempV.title)}
        </option>`;
    }, '')

    return /*html*/`
      <div class="${PTC}__swatch
        ${!hasVisibleOptions() ? CLASS_HIDDEN : ''}
      ">
        <select
          class="o-variant-selector o-select o-swatches__swatch-select
          o-input is-primary"
          data-variant-selector data-id="${v.id}"
        >
          ${options}
        </select>
        <a href="#" class="${PTC}__swatch-btn" data-upsell-add>
          <span class="${PTC}__swatch-btn-text o-tags">
            ${t('general.cart.recommendations_add')}
          </span>
        </a>
      </div>
    `
  }

  function image(){
    const featuredImage = p.featured_image.replace(/\/\//g, '')
    const imageHTML =  pictureGenerate({
      class: `${PTC}__image o-responsive-image`,
      src: featuredImage || '', // replace it with the actual img var
      srcSize: 750 // set your own sizes
    });

    const imageHTMLNoCDN = imageHTML.replace(/\/\/cdn.shopify.com/g, 'https://');

    const hoverImageHtml = pictureGenerate({
      class: `${PTC}__image o-responsive-image is-hover`,
      src: featuredImage || '', // replace it with the actual img var
      srcSize: 750 // set your own sizes
    });

    const hoverImageHTMLNoCDN = hoverImageHtml.replace(/\/\/cdn.shopify.com/g, 'https://');

    return /*html*/`
      <a
        href="${p.url}"
        title="${p.title}"
        class=" ${PTC}__image-container o-responsive-image__container"
        data-product-thumbnail-link
      >
        ${imageHTMLNoCDN}
        ${p.hover_image 
          ? hoverImageHTMLNoCDN
          : ''}
      </a>
    `
  }

  function pricing(){
    return /*html*/`
      <p class=" ${PTC}__price o-product-pricing">
        ${v.compare_at_price > v.price ? /*html*/`
          <span
            class=" ${PTC}__price-price o-product-pricing__compare" 
            data-product-money-compare data-currency
            data-money="${v.compare_at_price}"
          >
            ${printMoney(v.compare_at_price)}
          </span>
          <span
            class=" ${PTC}__price-price o-product-pricing__price" 
            data-product-money data-currency
            data-money="${v.price}"
          >
            ${printMoney(v.price)}
          </span>
        `: /*html*/`
          ${priceVaries ? /*html*/`
            <span
              class=" ${PTC}__price-price o-product-pricing__price" 
              data-product-money data-currency
              data-money="${priceMin}"
            >
              ${printMoney(priceMin)}
            </span>
            -
            <span
              class=" ${PTC}__price-price o-product-pricing__price" 
              data-product-money data-currency
              data-money="${priceMax}"
            >
              ${printMoney(priceMax)}
            </span>
          ` : /*html*/`
            <span
              class=" ${PTC}__price-price o-product-pricing__price" 
              data-product-money data-currency
              data-money="${v.price}"
            >
              ${printMoney(v.price)}
            </span>
          `}
        `}
      </p>
    `
  }
};
